<template>
  <div class="cencent">

    <!--头部-->
    <div class="title">
      <el-input size="mini" style="width: 200px" v-model="find_data.name" placeholder="请输入内容"></el-input>&nbsp;&nbsp;
      <el-button size="mini" type="primary" @click="find()">搜索</el-button>
      <el-button size="mini" @click="add_user" type="primary">新增</el-button>
    </div>
    <div style="height: 5px">
    </div>
    <!--主体-->
    <div class="subject">
      <el-table
        :header-cell-style="{background:'#000','color':'#fff',border:0}"
        :data="list"
        stripe
        border
        style="width: 90%"
        height="calc(100% - 60px)"
        show-overflow-tooltip="true"
      >
        <el-table-column
          align="center"
          width="80"
          label="操作">
          <template slot-scope="scope">
            <div style="display: flex;justify-content: space-around">
              <div style="color: #e6362d;cursor: pointer" v-if="scope.row.status==0" @click="update_status(1,scope.row._id)">终止</div>
              <!--              <div v-else style="color: #e6362d;cursor: pointer" @click="update_status(0,scope.row._id)">启用</div>-->
              <div style="color: #5198f3;cursor: pointer" @click="edit_info(scope.row)">编辑</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="username"
          width="200"
          align="center"
          label="联系人">
        </el-table-column>

        <el-table-column
          prop="adminphone"
          align="center"
          label="管理员账号">
        </el-table-column>


        <el-table-column
          align="center"
          label="到期日期">
          <template slot-scope="scope">
            {{ u.formatDateTime(2, scope.row.time) }}
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="新增时间">
          <template slot-scope="scope">
            {{ u.formatDateTime(2, scope.row.add_time) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="修改时间">
          <template slot-scope="scope">
            {{ u.formatDateTime(2, scope.row.update_time) }}
          </template>
        </el-table-column>


      </el-table>
      <div style="height: 5px"></div>
      <el-pagination

        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :page-size="size"
        :page-sizes="[10, 20, 30, 50]"
        :total="all_size">
      </el-pagination>
    </div>


    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="40px"
      append-to-body
      destroy-on-close
      :visible.sync="add_offer_status"
      v-if="add_offer_status"
    >
      <addusers @success="success" @close="close" :editInfo="editInfo"></addusers>
    </el-dialog>

  </div>
</template>

<script>

import addusers from "./add_users.vue"

import u from "../../../assets/js/util";

export default {

  components: {
    addusers
  },
  name: "index",
  data() {
    return {
      u: u,
      all_size: 0,
      page: 1,
      size: 10,
      find_data: {
        name: "",
      },
      list: [],
      add_offer_status: false,
      editInfo: {}
    }
  },
  async mounted() {
    // localStorage.setItem('appType', "account")
    // await u.post("users", "admin_auth", {})
    this.get_list(this.find_data)


    setInterval(() => {
      u.post("users", "getuserinfo",  false, false)
    }, 60000)


  },
  methods: {
    async update_status(status, _id) {
      var row = await u.post("users", "account_update", {
        where: {_id: _id},
        table: "enterprise",
        data: {status: Number(status)},
      })
      if (row !== false) {
        this.get_list(this.find_data)
      }
    },
    edit_info(data) {
      this.editInfo = data
      this.add_offer_status = true
    },
    close() {

      this.add_offer_status = false
    },
    find() {
      this.get_list(this.find_data)
    },
    handleCurrentChange(val) {
      this.page = val
      this.get_list(this.find_data)
    }
    ,
    handleSizeChange(val) {

      this.size = val
      this.get_list(this.find_data)
    },
    async get_list(data) {
      var list = await u.post("users", "account_list", {
        page: this.page,
        size: this.size,
        where: data,
        table: "enterprise",
        project: {secret: 0}
      })

      this.all_size = list[1]
      this.list = list[0]
    },
    success() {
      this.add_offer_status = false
      this.get_list(this.find_data)
    },
    add_user() {
      this.add_offer_status = true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/admin/index.vue